module.exports = __webpack_public_path__ + "static/media/IT.52c586da.svg";


//////////////////
// WEBPACK FOOTER
// ./src/svgs/flags/IT.svg
// module id = 282
// module chunks = 0